import { cn } from '@psspl/utils';

import { CompanyLogo } from '../brand/company-logo';
import { webEnv } from '../../lib/env';

export interface AppLogoProps {
  readonly className?: string | undefined;
  /** Hides the wordmark next to the logo, where the name is already on screen. */
  readonly showWordmark?: boolean;
}

/**
 * Header brand: the official Prakash Software Solutions logo, with the portal name
 * as the product identifier beside it.
 *
 * The logo is a real image asset, not text or CSS, and it is never replaced by a
 * placeholder. `alt` is empty because the adjacent wordmark already names the
 * company, so a screen reader must not announce it twice.
 */
export function AppLogo({ className, showWordmark = true }: AppLogoProps) {
  return (
    <span className={cn('flex min-w-0 items-center gap-3', className)}>
      <CompanyLogo size="sm" alt="" />
      {showWordmark ? (
        <span className="flex min-w-0 flex-col leading-tight">
          <span className="truncate text-sm font-semibold tracking-tight text-ink-primary">
            {webEnv.appName}
          </span>
          <span className="truncate text-[0.6875rem] text-ink-muted">{webEnv.companyName}</span>
        </span>
      ) : null}
    </span>
  );
}
